<template>
  <q-layout view="hHh lpR fff" :class="route.meta.hasHero ? 'bg-primary' : 'grey-background'">
    <NavBar />
    <q-page-container>
      <q-page>
        <router-view />
      </q-page>
    </q-page-container>
    <FooterComponent />
  </q-layout>

  <FavoriteProgrammesModal v-model="favoriteProgrammeStore.open" />
  <LoginModal v-model="authStore.loginModal" />
  <ProgramMatcher />
</template>

<script setup lang="ts">
import { useAuthStore } from 'stores/auth-store'
import { useFavoriteProgrammeStore } from 'stores/favorite_programme-store'
import { storeToRefs } from 'pinia'
import { useQuasar } from 'quasar'
import { useErrorStore } from 'stores/error-store'
import { watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { login } from 'src/utils/keycloakManager'

import FavoriteProgrammesModal from 'components/main/FavoriteProgrammesModal.vue'
import LoginModal from 'components/main/LoginModal.vue'
import NavBar from 'components/main/NavBar.vue'
import FooterComponent from 'components/main/FooterComponent.vue'
import ProgramMatcher from 'components/home/ProgramMatcher.vue'

const route = useRoute()
const router = useRouter()
const $q = useQuasar()

const authStore = useAuthStore()
const favoriteProgrammeStore = useFavoriteProgrammeStore()
const errorStore = useErrorStore()

const { error, status } = storeToRefs(errorStore)

watch(status, async (new_status) => {
  if (new_status != 0) {
    console.log(new_status)
    if (new_status == 409 || new_status == 400) {
      $q.notify({
        color: 'red',
        spinner: false,
        message: error.value,
        timeout: 2000,
      })
      errorStore.$reset()
    } else if (new_status == 401) {
      await login()
      errorStore.$reset()
    } else {
      await router.replace({
        name: 'Error',
        params: {
          catchAll: route.path.substring(4).split('/'),
        },
      })
    }
  }
})
</script>

<style scoped>
.dev-sticker {
  position: fixed;
  top: 60px;
  right: 20px;
  z-index: 9999;
}

:deep(.q-btn.btn--no-hover .q-focus-helper) {
  display: none;
}
</style>
